export default __webpack_public_path__ + "static/media/lock-yellow.b41a974b.svg";